
import React from "react";
import Herosection from "../component/UI/Herosection";
import Liveaction from "../component/UI/Live-Action/Liveaction";
import SellerSection from "../component/UI/Seller-section/SellerSection";
import TreandingSection from "../component/UI/TreandingSection/Treandingsection";
import Stepsection from "../component/UI/Step-Section/Stepsection";



function Home () {
    return(
        <>
            <Herosection />
            <Liveaction />
            <SellerSection />
            <TreandingSection />
            <Stepsection />


        </>
    ); 
}

export default Home;
